import { useEffect, useRef } from 'react'
import { Search, Trash2, UserPlus, Edit3 } from 'lucide-react'

interface FaceActionPopoverProps {
  onName: () => void
  onAssign: () => void
  onFindSimilar: () => void
  onDelete: () => void
  onClose: () => void
}

export default function FaceActionPopover({
  onName,
  onAssign,
  onFindSimilar,
  onDelete,
  onClose,
}: FaceActionPopoverProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose()
      }
    }
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [onClose])

  const items = [
    { label: 'Name this face', icon: Edit3, action: onName },
    { label: 'Assign to person', icon: UserPlus, action: onAssign },
    { label: 'Find similar', icon: Search, action: onFindSimilar },
    { label: 'Delete', icon: Trash2, action: onDelete, danger: true },
  ]

  return (
    <div
      ref={ref}
      className="absolute z-50 top-full mt-1 left-1/2 -translate-x-1/2 bg-popover border border-border rounded-lg shadow-lg py-1 min-w-[160px]"
    >
      {items.map((item) => (
        <button
          key={item.label}
          onClick={(e) => {
            e.stopPropagation()
            item.action()
            onClose()
          }}
          className={`w-full flex items-center gap-2 px-3 py-1.5 text-xs transition-colors ${
            item.danger
              ? 'text-red-400 hover:bg-red-600/10'
              : 'text-foreground hover:bg-secondary'
          }`}
        >
          <item.icon size={12} />
          {item.label}
        </button>
      ))}
    </div>
  )
}
